import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=6de4077e&scoped=true"
import script from "./orderList?vue&type=script&lang=js&external"
export * from "./orderList?vue&type=script&lang=js&external"
import style0 from "./orderList.vue?vue&type=style&index=0&id=6de4077e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4077e",
  null
  
)

export default component.exports